export default ({ theme }) => {
  return `
    width: 90%;
    /* height: 85%; */
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 10px;
    height: 400px;
    margin-top: 20px;

    .bar-chart-holder svg {
      height: 120% !important;
    }

    .totals-label-container{
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bolder;
      font-size: 28px;
      margin-bottom: 10px;
    
    }




  `
};